import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  FormProps,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';

export const TeleprompterScriptsSection = (props: FormProps) => {
  const { setFieldValue, values } = props;
  return (
    <Section>
      <SectionTitle>Teleprompter Scripts</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='preloadTeleprompterScripts'
          label='Preload Teleprompter Scripts'
          onChange={() => {
            setFieldValue(
              'preloadTeleprompterScripts',
              !values.preloadTeleprompterScripts
            );
          }}
        />
      </RowWrapper>
    </Section>
  );
};
